import { Badge, Flex, Text, Tooltip } from '@chakra-ui/react'
import { FC } from 'react'

interface Props {
  items: string[]
  emptyLabel?: string
}

const MultiItemCell: FC<Props> = ({ items, emptyLabel = '—' }) => {
  if (items.length === 0) return <Text color="gray.400">{emptyLabel}</Text>
  const [first, ...rest] = items
  return (
    <Flex align="center" gap={2}>
      <Text fontSize="13px">{first}</Text>
      {rest.length > 0 && (
        <Tooltip label={rest.join(' · ')} placement="right" hasArrow>
          <Badge
            colorScheme="blue"
            borderRadius="full"
            fontSize="11px"
            px={2}
            cursor="default"
          >
            +{rest.length}
          </Badge>
        </Tooltip>
      )}
    </Flex>
  )
}

export default MultiItemCell
